<script>
import loading from "@/components/elements/AppLoading.vue";
import {ExchangeRateService} from "@/services/ExchangeRateService";
import {AlertService} from "@/services/AlertService";

export default {
  name: "SettingsExchangeRates",
  components: {loading},
  data() {
    const startYear = 2011;
    const currentYear = new Date().getFullYear();

    return {
      months : [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      selectedMonth : new Date().getMonth() + 1,
      selectedYear : new Date().getFullYear(),
      years : Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i).reverse(),
      loading : true,
      list : []
    }
  },
  methods: {
    async getExchangeRate() {
      this.loading = true;
      this.list = await ExchangeRateService.getExchangeRate({
        month : this.selectedMonth,
        year : this.selectedYear,
      })
      this.loading = false;
    },
    async importTemplate() {
      if (this.$refs.er_template_input_file.files.length === 0) {
        return;
      }
      const file = this.$refs.er_template_input_file.files[0];

      if (await AlertService.confirmImportAlert() === true) {
        swal.fire({
          'title': `IMPORTING TEMPLATE FILE<br>Please wait.....`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        })
        swal.showLoading();
        const formData = new FormData();
        formData.append('file', file);

        const response = await ExchangeRateService.importExchangeRateTemplate(formData);
        swal.close()
        this.$refs.er_template_input_file.value = null
        if (response.success === true) {
          this.selectedMonth = response.month;
          this.selectedYear = response.year;
          const selectedMonth = this.months[this.selectedMonth - 1];
          AlertService.successAlert(`Exchange Rate for Month of ${selectedMonth} ${this.selectedYear} Template Has Been Successfully Imported!`, 'IMPORT FILE', 4000)

          await this.getExchangeRate();
        } else {
          const errorMessage = response.message.includes('invalid data') ? response.message : 'You imported an invalid template.';
          AlertService.errorAlert(errorMessage, 'IMPORT FILE', 4000)
        }
      }
    },
    async exportTemplate() {
      const selectedMonth = this.months[this.selectedMonth - 1];
      swal.fire({
        'title': `EXPORTING TEMPLATE FOR ${selectedMonth} ${this.selectedYear}<br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })

      swal.showLoading()

      const response = await ExchangeRateService.downloadExchangeRateTemplate({
        month : this.selectedMonth,
        year : this.selectedYear,
      });

      swal.close()

      if (response === false) {
        return;
      }

      const url = window.URL.createObjectURL(new Blob([response],{type:'application/vnd.ms-excel'}))
      let filename=`${this.selectedYear}.${this.selectedMonth} Exchange Rate for Month of ${selectedMonth} ${this.selectedYear}.xlsx`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    }
  },
  async created() {
    await this.getExchangeRate();
  }
}
</script>

<template>
  <div class="row">
    <div class="col-sm-8">
      <h3 class="text-left">Exchange Rates Settings</h3>
    </div>
    <div class="col-sm-4">
        <div class="float-right">
          <div class="row">
            <div class="col-md-auto pr-0">
              <label class="col-form-label pr-2 font-weight-bold">Month: </label>
            </div>
            <div class="col-md-auto pl-0">
              <select name="" id="" class="form-inline form-control form-control-sm form-control-xs" v-model="selectedMonth" @change="getExchangeRate">
                <option v-for="(month, index) in months" :value="index + 1">{{ month }}</option>
              </select>
            </div>
            <div class="col-md-auto pr-0">
              <label class="col-form-label pr-2 font-weight-bold">Year: </label>
            </div>
            <div class="col-md-auto pl-0">
              <select name="" id="" class="form-inline form-control form-control-sm form-control-xs" v-model="selectedYear" @change="getExchangeRate">
                <option v-for="year in years">{{ year }}</option>
              </select>
            </div>
          </div>
      </div>
    </div>

    <div class="col-12 pl-0 text-center col-lg-12">
      <div class="row no-gutters">
        <div class="col-7 pl-4">
        </div>
        <div class="col-5">
          <div class="float-right">
            <input type="file" ref="er_template_input_file" style="display:none" @change="importTemplate" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
            <button class="e-btn e-btn-blue force-white-all pr-3 mr-1" @click="$refs.er_template_input_file.click()">
              <font-awesome-icon icon="plus-square" style="width: 25px" />
              <small class="font-weight-bold">
                IMPORT TEMPLATE
              </small>
            </button>
            <button class="e-btn e-btn-blue-gray force-white-all pr-3 text-uppercase" @click="exportTemplate">
              <font-awesome-icon icon="file-excel" style="width: 25px" />
              <small class="font-weight-bold">
                DOWNLOAD BLANK TEMPLATE FOR {{ months[selectedMonth - 1] }} {{ selectedYear }}
              </small>
            </button>
          </div>
        </div>
        <table class="table table-sm table-bordered small mt-1">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" colspan="2">Currency</th>
            <th scope="col">EUR RATE</th>
            <th scope="col">US$RATE</th>
            <th scope="col">JPYRATE</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <loading></loading>
            </td>
          </tr>
          <template v-else>
            <tr v-for="(data, index) in list">
              <td>{{ index + 1 }}</td>
              <td>{{ data?.currency_name }}</td>
              <td>{{ data?.currency_code }}</td>
              <td>{{ data?.eur_rate }}</td>
              <td>{{ data?.usd_rate }}</td>
              <td>{{ data?.jpy_rate }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
